













import { Vue, Component, Prop } from 'vue-property-decorator';

import XSolid from '~/components/icons/XSolid.vue';

@Component({
  components: { XSolid },
})
export default class Toast extends Vue {
  @Prop(String) type: string;
  @Prop(String) text: '';

  /*
    Returns a type of toast with custom styles. For now only a success toast
    is implemented in project
  */
  get toastType () {
    switch (this.type) {
      case 'success': return { styles: 'text-success-default bg-success-50' };
    }
  }
}
